/** @jsx jsx */
import { jsx } from '@emotion/react'
import React, { Component } from 'react'
import Header from '../../../common/header'
import Footer from '../../../common/footer'
import s from './index.module.scss'
import i18next from 'i18next'

import { http } from '../../../common/request'
import { Button, Form, Input, message } from 'antd'

import { connect } from 'react-redux'
import actions from '../../../redux/action'
import {
  getQueryVariable,
  getStrQueryVariable,
  mobileCheck,
} from '../../../common/util'
import styled from '@emotion/styled'
import loginIcon from '../../../assets/login/bg.png'
import { HEADER_TABS } from '../../../redux/action/types'
import CountryCode from '../../../components/country-code'

class Login extends Component {
  constructor(props) {
    super(props)
    console.log('props:', props)
    this.state = {
      loginType: 'phone', //email or phone
      entryType: 'verifyCode', //password or verifyCode
      gettingCode: false,
      countDown: 60,
      email: '',
      phone: '',
      password: '',
      verifycode: '',
      t: '', //验证码登录参数
      code: 1, //OAuth使用
      access_key: '', //OAuth使用
      cid: '', //OAuth使用
      mobileCheck: false,
      redirectUrl: '',
      rejectLogin: '',
    }
  }

  formRef = React.createRef()

  componentDidMount() {
    this.setState({
      mobileCheck: mobileCheck(),
    })
    const cid = getQueryVariable('login_challenge')
    console.log('componentDidMount-cid:', cid)
    if (cid) {
      this.setState(
        {
          cid,
        },
        () => {
          this.consentRedirects()
        }
      )
    }
  }

  // 获取取消授权的url
  async consentRedirects() {
    const { cid } = this.state
    const params = {
      cid,
    }
    const res = await http('get', '/account/oauthUris', params).catch(
      (err) => {}
    )
    if (res && res.data && res.data.code === 0) {
      console.log(res, 'res of getConsentRedirects')
      if (res.data.data.reject_login) {
        this.setState({
          rejectLogin: res.data.data.reject_login.split('?')[0],
        })
      }
    } else {
      message.warn(res.data.desc)
    }
  }

  login(values) {
    const { entryType } = this.state
    if (entryType === 'verifyCode') {
      this.verifyLogin(values)
    } else {
      this.passwordLogin(values)
    }
  }

  //切换登录方式
  switchLoginType(type) {
    const { loginType, account } = this.state
    const tabType = type
    this.setState({
      loginType:tabType,
    })

    // alert(tabType + ' '+ loginType);
    // if (loginType === 'email') {
    //   this.setState({
    //     loginType: 'phone',
    //   })
    // } else {
    //   this.setState({
    //     loginType: 'email',
    //   })
    // }
  }

  //密码登录
  async passwordLogin(values) {
    const { account, password, country_code = '86' } = values
    const { cid } = this.state
    const params = {
      account,
      password,
      cid,
      country_code,
    }
    const res = await http('post', '/account/login', params).catch((err) => {})
    if (res && res.data && res.data.code === 0) {
      if (!!cid && res.data.data.redirect) {
        this.setState(
          {
            redirectUrl: res.data.data.redirect.split('?')[0],
            code: getStrQueryVariable('code', res.data.data.redirect),
            access_key:
              getStrQueryVariable('access_key', res.data.data.redirect) || '',
          },
          () => {
            console.log(res, this.state, 'xxxx')
            document.getElementById('form').submit()
          }
        )
      } else {
        this.saveUserInfo(res.data.data)
        this.props.history.push('/main')
        this.props.changedTab(HEADER_TABS.main)
      }
    } else {
      message.warn(res.data.desc)
    }
  }

  //发送验证码
  async getVerifyCode() {
    const account = this.formRef.current.getFieldValue('account')
    let countryCode =
      this.state.loginType === 'phone'
        ? {
            country_code:
              this.formRef.current.getFieldValue('country_code') || '86',
          }
        : {}
    const res = await http('post', '/account/requestVerify', {
      account,
      ...countryCode,
    }).catch((err) => {})
    if (res && res.data && res.data.code === 0) {
      this.setState({
        t: res.data.data.t,
      })
    }
    if (res && res.data && res.data.code !== 0) {
      message.warning(res.data.desc)
      return
    }

    this.setState({
      gettingCode: true,
    })

    let { countDown } = this.state

    this.conutDownTimer && clearInterval(this.conutDownTimer)
    this.conutDownTimer = setInterval(() => {
      const num = countDown--
      if (num >= 0) {
        this.setState({
          countDown: num,
        })
      } else {
        this.setState({
          gettingCode: false,
        })
        clearInterval(this.conutDownTimer)
      }
    }, 1000)
  }

  //验证码登录
  async verifyLogin(values) {
    const { t, cid } = this.state
    const { password, country_code = '86' } = values
    const params = {
      t,
      code: password,
      cid,
      country_code,
    }
    const res = await http('post', '/account/verify', params).catch((err) => {})
    if (res && res.data && res.data.code === 0) {
      if (cid && res.data.data.redirect) {
        this.setState(
          {
            redirectUrl: res.data.data.redirect,
            code: getStrQueryVariable('code', res.data.data.redirect),
            access_key:
              getStrQueryVariable('access_key', res.data.data.redirect) || '',
          },
          () => {
            document.getElementById('form').submit()
          }
        )
      } else {
        this.saveUserInfo(res.data.data)
        this.props.history.push('/main')
        this.props.changedTab(HEADER_TABS.main)
      }
    } else {
      message.warn(res.data.desc)
    }
  }

  //存储登录信息
  saveUserInfo(data) {
    data && localStorage.setItem('userInfo', JSON.stringify(data))
  }

  //动态校验
  validateDynamic() {
    const { loginType } = this.state
    let ruleConfig = [
      {
        required: true,
        message: i18next.t("input_account"),
      },
    ]
    ruleConfig.push({
      type: loginType === 'email' ? 'email' : '',
      message:
      i18next.t("input_correct")+ (loginType === 'email' ? i18next.t('email_txt') : i18next.t('phone_txt')),
    })

    return ruleConfig
  }

  //取消授权
  cancelConsent() {
    document.getElementById('reject').submit()
  }

  render() {
    const { locale } = this.props
    const {
      loginType,
      entryType,
      gettingCode,
      countDown,
      mobileCheck,
      redirectUrl,
      access_key,
      cid,
      code,
      rejectLogin,
    } = this.state

    let form_item1_placeholder, form_item2_placeholder
    if (locale === 'en') {
      form_item1_placeholder =
        loginType === 'email'
          ? 'Please input email'
          : 'Please input phone number'
      form_item2_placeholder =
        entryType === 'password'
          ? 'Please input password'
          : 'Please input verification code'
    } else {
      form_item1_placeholder =
        loginType === 'email' ? '请输入邮箱' : '请输入手机号'
      form_item2_placeholder =
        entryType === 'password' ? '请输入密码' : '请输入验证码'
    }
    return (
      <Container>
        <IconContainer>
          <Icon src={loginIcon} />
        </IconContainer>
        <LoginContainer>
          <div>
            {mobileCheck ? null : <Header props={this.props} />}
            <div className={s.container}>
              {/* <div className={s.welcome}>{i18next.t('welcome')}</div> */}
              <div
                    className={s.change_submit}
                  >
                    <span className={loginType === 'phone'?(s.loginTypeTab + ' '+ s.active):s.loginTypeTab} onClick={() => this.switchLoginType('phone')}>{i18next.t('phone_login')}</span>
                    <span className={loginType === 'phone'?s.loginTypeTab:(s.loginTypeTab +' '+ s.active)} onClick={() => this.switchLoginType('email')}>{i18next.t('email_login')}</span>
                    <span className={loginType === 'email'?s.activeTab+ ' '+ s.tabMove:s.activeTab} ></span>
                    {/* <a href="#header">
                      {i18next.t(
                        loginType === 'email' ? 'phone_login' : 'email_login'
                      )}
                    </a> */}
              </div>
              <div style={{padding:'30px 40px'}}>
              
              <Form
                name="basic"
                ref={this.formRef}
                onFinish={(values) => {
                  this.login(values)
                }}
                onFinishFailed={() => {
                  console.log('failed')
                }}
              >
                <div className={s.login_wrapper}>
                  <div className={s.login_type}>
                    {i18next.t(loginType === 'email' ? 'email' : 'phone')}
                  </div>
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      marginBottom: 15,
                      // overflow:'hidden'
                    }}
                  >
                    {this.state.loginType !== 'email' && (
                      <Form.Item name={'country_code'}>
                        <CountryCode bordered={true} displayName={true} />
                      </Form.Item>
                    )}
                    
                    <Form.Item
                      style={{ display: 'flex', flex: 1 }}
                      label=""
                      name="account"
                      rules={this.validateDynamic()}
                    >
                      <Input
                        className={s.login_input}
                        placeholder={form_item1_placeholder}
                      />
                    </Form.Item>
                  </div>

                  <div className={s.login_type}>
                    {i18next.t(entryType === 'password' ? 'password' : 'code')}
                  </div>
                  {entryType === 'password' ? (
                    <Form.Item
                      label=""
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: form_item2_placeholder,
                        },
                      ]}
                    >
                      {entryType === 'password' ? (
                        <Input.Password
                          className={s.login_input}
                          placeholder={form_item2_placeholder}
                        />
                      ) : (
                        <Input
                          className={s.login_input}
                          placeholder={form_item2_placeholder}
                        />
                      )}
                    </Form.Item>
                  ) : (
                    <Form.Item
                      label=""
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: form_item2_placeholder,
                        },
                      ]}
                    >
                      <Input
                        className={s.login_input}
                        placeholder={form_item2_placeholder}
                      />
                    </Form.Item>
                  )}

                  {entryType === 'password' ? null : (
                    <div
                      className={s.get_verify_code}
                      onClick={() => this.getVerifyCode()}
                    >
                      {gettingCode ? (
                        <div className={s.count_down}>{countDown} s</div>
                      ) : (
                        i18next.t('send')
                      )}
                    </div>
                  )}
                </div>

                <div className={s.change_type}>
                 

                  {entryType === 'password' ? (
                    <div
                      className={s.change_verify_type}
                      onClick={() => this.setState({ entryType: 'verifyCode' })}
                    >
                      <a href="#header">{i18next.t('via_verify')}</a>
                    </div>
                  ) : (
                    <div
                      className={s.change_verify_type}
                      onClick={() => this.setState({ entryType: 'password' })}
                    >
                      <a href="#header">{i18next.t('via_password')}</a>
                    </div>
                  )}
                </div>

                <Form.Item>
                  <Button className={s.submit} type="primary" htmlType="submit">
                    {i18next.t('login')}
                  </Button>
                </Form.Item>
              </Form>

              {cid ? (
                <div className={s.cancel} onClick={() => this.cancelConsent()}>
                  {i18next.t('cancel')}
                </div>
              ) : null}

              {mobileCheck ? null : (
                <div className={s.extra} style={{fontSize:'12px'}}>
                  {i18next.t('desc_1')}
                  <a
                    href="https://www.qingping.co/qingpingiot"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{i18next.t('desc_1_1')}
                  </a>
                  {i18next.t('desc_2')}
                  <a
                    href="https://www.qingping.co/plus"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {i18next.t('desc_3')}
                  </a>
                  {i18next.t('desc_4')}
                </div>
              )}
              </div>
              
            </div>
            {mobileCheck ? null : <Footer color={'#fff'} />}
            <form
              style={{ display: 'none' }}
              action={redirectUrl}
              method="POST"
              id="form"
            >
              <input
                type="hidden"
                id="access_key"
                name="access_key"
                value={access_key}
              />
              <input type="hidden" id="cid" name="cid" value={cid} />
              <input type="hidden" id="code" name="code" value={code} />
            </form>

            <form
              style={{ display: 'none' }}
              action={rejectLogin}
              method="POST"
              id="reject"
            >
              <input type="hidden" id="cid" name="cid" value={cid} />
              <input type="hidden" id="code" name="code" value="1" />
            </form>
          </div>
        </LoginContainer>
      </Container>
    )
  }
}

const Container = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: row;
  background: linear-gradient(20deg, #93a7f1 0%, #90a3ee 100%);
  align-items: center;
`

const IconContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 60px;
  //background-color: red;
`

const Icon = styled.img`
  height: 678px;
  width: 678px;
  margin-left: 10vw;
`

const LoginContainer = styled.div`
  flex: 1;
  height: 90vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const mapStateToProps = (state) => ({
  locale: state.language.language,
})
const mapDispatchToProps = (dispatch) => ({
  changeLanguage: (val) => dispatch(actions.onChangeLanguage(val)),
  changedTab: (tab) => dispatch(actions.onChangeTab(tab)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
